import * as z from "zod";

export const sendReviewEditEmail = {
  name: "sendReviewEditEmail" as const,
  input: z.object({
    reviewId: z.string(),
    teamId: z.string(),
    emailTemplate: z.object({
      subject: z.string(),
      content: z.string(),
      dynamicVariables: z.record(z.string(), z.string()).optional(),
    }),
  }),
  output: z.object({
    success: z.boolean(),
    emailSent: z.boolean(),
    emailError: z.string().nullable(),
    editLink: z.string(),
  }),
};
